export class AuthenticationTokenExpiry {
  public expiryDate: Date;
  public expirySeconds: number;
}
